import { DialogActions, SxProps, Theme } from '@mui/material';
import clsx from 'clsx';
import { useMemo } from 'react';

import { AxleDialogShellFooterProps } from './AxleDialogShell.types';

export const AxleDialogShellFooter = ({
    showScrollShadow = false,
    className = '',
    children,
    sx,
    ...rest
}: AxleDialogShellFooterProps) => {
    const footerSx = useMemo(
        (): SxProps<Theme> => ({
            gridRow: 3,
            px: 3,
            py: 2,
            gap: 1,
            borderTop: '1px solid',
            borderColor: 'divider',
            backgroundColor: 'grey.50',
            boxShadow: showScrollShadow ? '0 -2px 6px rgba(0, 0, 0, 0.08)' : 'none',
            ...sx,
        }),
        [showScrollShadow, sx],
    );

    return (
        <DialogActions
            className={clsx('axle-dialog-shell-footer', className)}
            sx={footerSx}
            {...rest}
        >
            {children}
        </DialogActions>
    );
};
